function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 5295"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154448",
    style: {
      fill: "none"
    },
    d: "M0 0h16v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.5-811.034 1.841 1.841v1.544h-4.671v5.661l-.772.772-.772-.772v-5.661h-4.666v-1.544l1.841-1.841v-7.422h-1.029V-820h9.262v1.544H277.5z",
    transform: "translate(-265.46 822)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.794b5b1a8099a83b6413cdf3342b09f0.svg";
export { ForwardRef as ReactComponent };